import {
    convertDateToServerDateTypeMoment,
    convertTimestampToMomentObject,
} from '../../../../Utils/timeConvertorHelper';

export const getUserPlans = planMembers => {
    if (planMembers.length !== 0)
        return {
            expiration: planMembers[0].expiresAt,
            value: planMembers[0].plan.id,
            title: planMembers[0].plan.name,
            planMemberId: planMembers[0].id,
        };

    return {};
};

export const getCredits = planMembers => {
    if (planMembers.length !== 0) return planMembers[0].credits;
    return null;
};

export const getPaidUntil = planMembers => {
    if (planMembers.length !== 0 && planMembers[0].expiresAt)
        return convertDateToServerDateTypeMoment(convertTimestampToMomentObject(planMembers[0].expiresAt));
    return null;
};

export const getAvailablePlans = plansAvailable => {
    return plansAvailable.map(plan => {
        return { value: plan.id, title: plan.name };
    });
};

export const displayPlansSelected = plans => {
    return plans.join(', ');
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MemberRow/utils.js